import scrollbar from '@fukku/styles/src/scrollbar.module.css'
import { cx } from 'classix'
import { type ReactNode, useRef, useState } from 'react'
import styles from './Content.module.css'

export function Content({
	children,
	className = '',
	'data-testid': dataTestId,
	hasPadding = true,
}: Readonly<{
	children: ReactNode
	className?: string
	'data-testid'?: string
	hasPadding?: boolean
}>) {
	const [scrolling, setScrolling] = useState(false)
	const contentRef = useRef<HTMLDivElement | null>(null)

	return (
		<div
			data-scrolling={scrolling ? 'true' : undefined}
			data-type='content'
			onScroll={(e) => {
				if ((contentRef.current?.scrollTop ?? 0) > 0) {
					setScrolling(true)
				}
				e.preventDefault()
			}}
			onTouchEnd={() => {
				if (scrolling && (contentRef.current?.scrollTop ?? 0) === 0) {
					setTimeout(() => {
						setScrolling(false)
					})
				}
			}}
			ref={contentRef}
			data-testid={dataTestId}
			className={cx(
				scrollbar.className,
				styles.content,
				!hasPadding && styles.noPadding,
				className
			)}
		>
			{children}
		</div>
	)
}
